const financialEnvelope = [
  {
    path: '/financial/envelopes',
    name: 'Envelopes',
    redirect: { name: 'OpenEnvelopes' },
    meta: {
      auth: true,
      roles: ['Director', 'SalesExecutive', 'Manager', 'Analyst', 'Financial', 'Logistics', 'CreditAnalyst'],
    },
    component: () => import('@/_backoffice/_financial/components/envelope/Envelopes'),
    children: [
      {
        meta: {
          auth: true,
          roles: ['Director', 'SalesExecutive', 'Manager', 'Analyst', 'Financial', 'Logistics', 'CreditAnalyst'],
        },
        path: 'open',
        name: 'OpenEnvelopes',
        component: () => import('@/_backoffice/_financial/components/envelope/OpenEnvelopes'),
      },
    ]
  },
  {
    path: '/financial/envelopes/cash/create',
    name: 'NewCash',
    meta: {
      auth: true,
      roles: ['Director', 'SalesExecutive', 'Manager', 'Analyst', 'Financial', 'Logistics', 'CreditAnalyst'],
    },
    component: () => import('@/_backoffice/_financial/components/order_payment/NewCash'),
  },
  {
    path: '/financial/envelopes/check/create',
    name: 'NewCheck',
    meta: {
      auth: true,
      roles: ['Director', 'SalesExecutive', 'Manager', 'Analyst', 'Financial', 'Logistics', 'CreditAnalyst'],
    },
    component: () => import('@/_backoffice/_financial/components/order_payment/NewCheck'),
  },
]

export default financialEnvelope
